import React from 'react';
import '../styles/App.css';

import InputForm from './InputForm'
import Tab from './Tab'
import {BloodIcon, BasicIcon, BikeIcon} from './SVGCollection'

import _ from 'lodash';
import * as d3 from 'd3';


class InputPanel extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            clickedTab: 'basic_measurements',
            'tabRefs': {
                //TODO do this dynamically 
                'basic_measurements': React.createRef(),
                'lifestyle': React.createRef(),
                'biomarkers': React.createRef()
            },
            'formRefs': {
                //TODO do this dynamically 
                'basic_measurements': React.createRef(),
                'lifestyle': React.createRef(),
                'biomarkers': React.createRef()
            },
            'currentForm': 'basic_measurements'
        }
    }

    highlightNode(node){
        node.style.animationName = 'tabHighlight'
        node.style.animationDuration = '0.7s'
        setTimeout(function(){
            node.style.animationName = null
        }, 700)
    }

    handleTabClick(clickedTab){
        // get index of tab in input vars
        // if previous item is not 100% filled in, disable tab click.state
        // else update state

        let previousClickedTab = this.state.clickedTab

        let classes = Object.keys(this.state.progressPercentagePerClass)
        let values = Object.values(this.state.progressPercentagePerClass)

        let index = classes.indexOf(clickedTab)
        let indexLastTabFilledIn = values.indexOf(1)

        let previousTab = classes[index-1]
        let previousTabProgress = this.state.progressPercentagePerClass[previousTab] 
        
        if (indexLastTabFilledIn === -1 && clickedTab !== classes[0]){ 
            //if no tab is completed yet and clickedTab is not the first one, highight the first tab
            this.highlightNode(this.state.tabRefs[classes[0]].current)

        } else if (previousTab !== undefined && previousTabProgress !== 1) {
            //if clicked tab is not the first one (previousTab === undefined) and the previous tab 
            //is not completed yet, highlight tab [indexTabFilledIn+1]
            this.highlightNode(this.state.tabRefs[classes[indexLastTabFilledIn+1]].current)
        } else {
            
            // let previousFormNode = this.state.formRefs[previousClickedTab].current
            // let currentFormNode = this.state.formRefs[clickedTab].current     

            // currentFormNode.style.animationDuration = '0.7s'
            // previousFormNode.style.animationDuration = '0.7s'
            // currentFormNode.style.animationName = 'slideIn'
            // previousFormNode.style.animationName = 'slideOut'
           
            // currentFormNode.style.visibility = 'visible'

            // setTimeout(function(){
            //     previousFormNode.style.visibility = 'hidden'
            // }, 700)            

            this.setState({
                clickedTab: clickedTab,
                currentForm: clickedTab
            })

        }
    }

    handleProgress(){
        let filledIn = _.filter(this.props.inputVars, function(o){
            return(o.inputValue !== null && o.class === this.state.clickedTab)
        }.bind(this)).length

        let progressPercentagePerClass = this.state.progressPercentagePerClass
        progressPercentagePerClass[this.state.clickedTab] = filledIn/this.state.totalVarsPerClass[this.state.clickedTab]

        this.setState({
            progressPercentagePerClass: progressPercentagePerClass
        })
    }

    handleClick(inputValue, inputName){
        this.props.handleInput(inputValue, inputName)
        this.handleProgress()
    }

    componentDidUpdate(prevProps, prevState){
        if (prevProps.inputVars.length !== this.props.inputVars.length){
            var totalVarsPerClass = _.countBy(this.props.inputVars, 'class')
            var zeroPerClass = _.mapValues(totalVarsPerClass, function(val){
                return(0)
            })

            this.setState({
                totalVarsPerClass: totalVarsPerClass,
                progressPercentagePerClass: zeroPerClass
            })
        }
    }

    render() {
        let noProgress = this.state.progressPercentagePerClass === undefined
        // let currentForm = this.state.clickedTab === 'basic_measurements' ? 
        let currentForm = this.state.currentForm === 'basic_measurements' ? 
            <div className='col' id='basic_measurements'><InputForm key='basic_measurements' data={ _.filter(this.props.inputVars, function(o){return(o.class === 'basic_measurements')}.bind(this))} handleClick={this.handleClick.bind(this)} /></div>
            : this.state.currentForm === 'lifestyle' ? 
            <div className='col' id='lifestyle'><InputForm key='lifestyle'  data={ _.filter(this.props.inputVars, function(o){return(o.class === 'lifestyle')}.bind(this))} handleClick={this.handleClick.bind(this)} /></div>
            : this.state.currentForm == 'biomarkers' ?
            <div className='col' id='biomarkers'><InputForm key='biomarkers'  data={ _.filter(this.props.inputVars, function(o){return(o.class === 'biomarkers')}.bind(this))} handleClick={this.handleClick.bind(this)} /></div>
            : null

        return(
            <div className='container w-100 d-flex flex-column' style={{paddingTop: '30px', minHeight: '100%'}}>
                <div className='title' style={{textAlign: 'right'}}>INPUT</div>
                {/*<div style={{marginBottom: '10px'}} className='row justify-content-center'>*/}
                    {/*<div className='col'><Tab reference={this.state.tabRefs['basic_measurements']} onClick={this.handleTabClick.bind(this, 'basic_measurements')} icon={BasicIcon} progressPercentage={noProgress ? 0 : this.state.progressPercentagePerClass['basic_measurements']} /></div>
                    <div className='col'><Tab reference={this.state.tabRefs['lifestyle']} onClick={this.handleTabClick.bind(this, 'lifestyle')} icon={BikeIcon} progressPercentage={noProgress ? 0 : this.state.progressPercentagePerClass['lifestyle']} /></div>
                    <div className='col'><Tab reference={this.state.tabRefs['biomarkers']} onClick={this.handleTabClick.bind(this, 'biomarkers')} icon={BloodIcon} progressPercentage={noProgress ? 0 : this.state.progressPercentagePerClass['biomarkers']} /></div>*/}
                {/*</div>*/}
                

                {/*<div className='row d-flex flex-column'>*/}
                <div className='input-form-container row'>
                    {currentForm}

                    {/*<div className='input-form' style={{visibility: 'visible', display: 'inline-block'}} ref={this.state.formRefs['basic_measurements']}><InputForm data={ _.filter(this.props.inputVars, function(o){return(o.class === 'basic_measurements')}.bind(this))} handleClick={this.handleClick.bind(this)} /></div>
                    <div className='input-form' style={{visibility: 'hidden', display: 'inline-block'}} ref={this.state.formRefs['lifestyle']}><InputForm data={ _.filter(this.props.inputVars, function(o){return(o.class === 'lifestyle')}.bind(this))} handleClick={this.handleClick.bind(this)} /></div>
                    <div className='input-form' style={{visibility: 'hidden', display: 'inline-block'}} ref={this.state.formRefs['biomarkers']}><InputForm data={ _.filter(this.props.inputVars, function(o){return(o.class === 'biomarkers')}.bind(this))} handleClick={this.handleClick.bind(this)} /></div>
                    */}
                </div>

            </div>
        )
    }
}

export default InputPanel